import React, { useState, useEffect } from 'react';
import Layout from '../../Components/Layout';
import { Icon } from '@iconify/react'; // ✅ Correct import
import { TableBody, TableHead } from '@mui/material';
import { BigText, btnfont, LightDark, LighterBig, LighterBold } from '../../Assets/CSS/Text';
import AddEmployeeModal from '../../Components/common/AddEmployeeModel';
import AddNewDepartment from '../../Components/Model/AddNewDepartment';
import profileImage from '../../../src/Assets/Images/Profile.png';
import '../../Assets/CSS/Department.css'
import { Modal } from 'react-bootstrap';
import axios from 'axios';
import ViewDepartment from '../../Components/Model/ViewDepartment';
import Role from './Role';
import EditDepartment from '../../Components/Model/EditDepartment';
import DeleteDepartment from '../../Components/Model/DeleteDepartment';
import { format } from "date-fns";
import { Newbtn } from '../../Assets/CSS/Button';

const DepartmentRole = () => {
    const [departments, setDepartments] = useState([]);
    const [searchQuery, setSearchQuery] = useState("");
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [isDeleting, setIsDeleting] = useState(false);
    const [showAddDeptModal, setShowAddDeptModal] = useState(false);
    const [showViewDeptModal, setShowViewDeptModal] = useState(false);
    const [showEditDeptModal, setShowEditDeptModal] = useState(false);
    const [activeTab, setActiveTab] = useState("Department");
    const [DepartmentData, setDepartment] = useState([]);
    const [statusFilter, setStatusFilter] = useState('Department');
    const [showModal, setShowModal] = useState(false);
    const [loading, setLoading] = useState(false);
    const [viewType, setViewType] = useState("list"); // 👈 new state
    const [selectedDept, setSelectedDept] = useState(null);
    // Pagination states
    const [currentPage, setCurrentPage] = useState(0); // Page index starts at 0
    const [pageSize] = useState(10); // 10 records per page
    const [totalPages, setTotalPages] = useState(0);
    const [totalElements, setTotalElements] = useState(0);

    const departmentColors = {
        'human resources': { background: '#FFF5CC', color: '#A67C00' },
        'ux ui design': { background: '#F0CEFF', color: '#9200A6' },
        'finance department': { background: '#E0F7FA', color: '#00796B' },
        'project management': { background: '#CEFBFF', color: '#00A69D' },
        'information technology': { background: '#E1E0FF', color: '#3F00A6' },
        'sales department': { background: '#FFE0CC', color: '#A63B00' },
        'marketing department': { background: '#FFE6F0', color: '#A60047' },
        'operations department': { background: '#E0FFE0', color: '#008A00' },
        'customer support': { background: '#E0F0FF', color: '#0057A6' },
        'logistics department': { background: '#FFF2E0', color: '#A65E00' },
        'procurement department': { background: '#E6FFF5', color: '#008A63' },
        'production department': { background: '#FFF0E6', color: '#A63C00' },
        'research and development': { background: '#E6E0FF', color: '#5C00A6' },
    };



    // Fetch departments (GET API)
    const fetchDepartments = async (page = 0) => {
        try {
            setLoading(true);
            const token = localStorage.getItem("token"); // or wherever you store it
            const response = await axios.get(
                `${process.env.REACT_APP_BACKEND_URL}/api/v1/depts?page=${page}&size=${pageSize}`,
                {
                    headers: {
                        Authorization: `Bearer ${token}`
                    }
                }
            );
            const { content = [], totalPages = 1 } = response.data;
            setDepartments(content);
            setTotalPages(totalPages);
            setCurrentPage(page);

        } catch (error) {
            console.error("Error fetching departments:", error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchDepartments(currentPage);
    }, [currentPage]);

    // Helper function to get colors
    const getDeptColors = (deptName) => {
        if (!deptName) return { background: '#FFFACE', color: '#A69500' }; // default
        const key = deptName.toLowerCase().trim();
        return (
            Object.entries(departmentColors).find(([k]) => key.includes(k))?.[1] || {
                background: '#FFFACE',
                color: '#A69500',
            }
        );
    };


    const handleDeleteDepartment = async () => {
        if (!selectedDept) return;
        alert(`${selectedDept.name} deleted successfully!`);
        console.log(`${selectedDept.name} deleted successfully!`);
        setIsDeleting(false);
        setShowDeleteModal(false)
        // try {
        //     setIsDeleting(true);

        //     // 🧠 Example API call — update this URL for your backend
        //     const token = localStorage.getItem("token");
        //     await axios.delete(
        //         `${process.env.REACT_APP_BACKEND_URL}/api/v1/departments/${selectedDept.id}`,
        //         {
        //             headers: { Authorization: `Bearer ${token}` },
        //         }
        //     );

        //     // ✅ Success feedback
        //     alert(`${selectedDept.name} deleted successfully!`);
        //     setShowDeleteModal(false);
        // } catch (error) {
        //     console.error("Error deleting department:", error);
        //     alert("Failed to delete department.");
        // } finally {
        //     setIsDeleting(false);
        // }
    };

    const filteredData = departments.filter((d) =>
        (d.name || "").toLowerCase().includes((searchQuery || "").trim().toLowerCase())
    );


    const isMobile = window.innerWidth <= 768;

    return (
        <Layout>
            <div className="backgound-main-content ">

                {/* ================= Filter Tabs + Add Button ================= */}
                <div
                    className="filters d-flex flex-wrap justify-content-between align-items-center gap-2"
                    style={{ borderBottom: "2px solid #DBDBDB" }}
                >
                    <div className="d-flex flex-wrap gap-3">
                        {["Department", "Roles"].map((tab) => (
                            <button
                                key={tab}
                                className={`tab-btn ${statusFilter === tab ? "active" : ""}`}
                                onClick={() => setStatusFilter(tab)}
                                style={{
                                    color: statusFilter === tab ? "#00AFEF" : "#909090",
                                    background: "transparent",
                                    border: "none",
                                    cursor: "pointer",
                                    fontSize: isMobile ? "18px" : "24px",
                                }}
                            >
                                {tab}
                            </button>
                        ))}
                    </div>

                    {/* Add Department only visible for Department tab */}
                    {statusFilter === "Department" && (
                        <>
                            <button
                                className="  
                                d-none d-md-flex align-items-center gap-1  px-3 py-2"
                                style={{
                                    ...btnfont,
                                    ...Newbtn
                                }}

                                onClick={() => setShowAddDeptModal(true)}
                            >
                                <Icon icon="material-symbols:add-rounded" width="18" height="18" />
                                Department
                            </button>

                            <button
                                className="add-emp-mob-button d-md-none"
                                onClick={() => setShowAddDeptModal(true)}
                            >
                                <div className="add-emp-icon-mob-container">
                                    <Icon
                                        icon="material-symbols:add-rounded"
                                        width="18"
                                        height="18"
                                        style={{ color: "#00AFEF" }}
                                    />
                                </div>
                            </button>
                        </>
                    )}
                </div>

                {/* ================== Tab Content ================== */}
                <div className="mt-4">

                    {/* ===== Department Section (Default) ===== */}
                    {statusFilter === "Department" && (
                        <>
                            {/* Search + View Toggle */}
                            <div className="d-flex flex-wrap align-items-center justify-content-between mt-3 gap-2">
                                <div
                                    className="position-relative flex-grow-1"
                                    style={{ maxWidth: "400px", minWidth: "200px" }}
                                >
                                    <Icon
                                        icon="iconamoon:search"
                                        width="20"
                                        height="20"
                                        className="position-absolute text-primary"
                                        style={{ top: "50%", right: "12px", transform: "translateY(-50%)" }}
                                    />
                                    <input
                                        type="text"
                                        className="form-control ps-3 rounded-4"
                                        placeholder="Search Department"
                                        value={searchQuery}
                                        onChange={(e) => setSearchQuery(e.target.value)}
                                    />
                                </div>

                                <div className="d-flex align-items-center justify-content-end flex-wrap">
                                    <Icon
                                        icon="material-symbols:list-rounded"
                                        width="28"
                                        height="28"
                                        className={`border rounded p-1 me-2 cursor-pointer ${viewType === "list" ? "text-primary" : "text-secondary"
                                            }`}
                                        onClick={() => setViewType("list")}
                                    />
                                    <Icon
                                        icon="bxs:grid"
                                        width="28"
                                        height="28"
                                        className={`border rounded p-1 cursor-pointer ${viewType === "grid" ? "text-primary" : "text-secondary"
                                            }`}
                                        onClick={() => setViewType("grid")}
                                    />
                                </div>
                            </div>

                            {/* ===== Department Table or Grid View ===== */}
                            {viewType === "list" ? (
                                <div className="table-responsive mt-4">
                                    <table>
                                        <thead>
                                            <tr className="border rounded">
                                                <th style={LighterBold}>Department Name</th>
                                                <th style={LighterBold}>Head of Department</th>
                                                {/* <th style={LighterBold}>Contact Details</th> */}
                                                <th style={LighterBold}>Created On</th>
                                                <th style={LighterBold}>
                                                    <div className="d-flex flex-column align-items-start lh-1">
                                                        <span>Total</span>
                                                        <span>Employees</span>
                                                    </div>
                                                </th>
                                                <th style={LighterBold}>Actions</th>
                                            </tr>
                                        </thead>
                                        {/* <tbody>
                                            {filteredData.map((dept) => (
                                                <tr key={dept.id}>
                                                    <td style={LightDark}>
                                                        <div className="d-flex align-items-center gap-2">
                                                            <span
                                                                className="bg-success rounded-circle"
                                                                style={{ width: 8, height: 8 }}
                                                            ></span>
                                                            {dept.name || 'N/A'}
                                                        </div>
                                                    </td>
                                                    <td style={LightDark}>{dept.headName || 'N/A'}</td>
                                                    <td style={LightDark}>
                                                        <div className="text-muted small">
                                                            {dept.headEmail || 'N/A'}
                                                            <br />
                                                            {dept.headPhoneNumber || 'N/A'}
                                                        </div>
                                                    </td>
                                                    <td style={LightDark}>{dept.created || 'N/A'}</td>
                                                    <td style={LightDark}>
                                                        {dept.employeeNames && dept.employeeNames.length > 0 ? dept.employeeNames.length : 'N/A'}
                                                    </td>

                                                    <td style={LightDark}>
                                                        <div className="d-flex gap-3">
                                                            <Icon
                                                                icon="hugeicons:view"
                                                                width="20"
                                                                className=" cursor-pointer"
                                                                style={{ color: '#00AFEF' }}
                                                                onClick={() => {
                                                                    setSelectedDept(dept);       // store the clicked department
                                                                    setShowViewDeptModal(true);  // open modal
                                                                }}
                                                            />
                                                            <Icon
                                                                icon="mdi:edit"
                                                                width="20"
                                                                className=" cursor-pointer"
                                                                style={{ color: '#00AFEF' }}
                                                                onClick={() => {
                                                                    setSelectedDept(dept);
                                                                    setShowEditDeptModal(true);
                                                                }}
                                                            />
                                                            <Icon
                                                                icon="material-symbols:delete-outline"
                                                                width="20"
                                                                className=" cursor-pointer"
                                                                style={{ color: '#DD0000' }}
                                                                onClick={handleOpenModal}
                                                            />
                                                        </div>
                                                    </td>
                                                </tr>
                                            ))}

                                            {filteredData.length === 0 && (
                                                <tr>
                                                    <td colSpan="6" className="text-center text-muted py-3">
                                                        No Department Found
                                                    </td>
                                                </tr>
                                            )}
                                        </tbody> */}
                                        <tbody>
                                            {filteredData.map((dept) => (
                                                <tr key={dept.departmentId}>
                                                    <td style={LightDark}>
                                                        <div className="d-flex align-items-center gap-2">
                                                            <span
                                                                className="bg-success rounded-circle"
                                                                style={{ width: 8, height: 8 }}
                                                            ></span>
                                                            {dept.name || 'N/A'}
                                                        </div>
                                                    </td>
                                                    <td style={LightDark}>{dept?.headName || 'N/A'}</td>
                                                    {/* <td style={LightDark}>
                                                        <div className="text-muted small">
                                                            {dept.headEmail || 'N/A'}
                                                            <br />
                                                            {dept.headPhoneNumber || 'N/A'}
                                                        </div>
                                                    </td> */}
                                                    <td style={LightDark}>


                                                        <span>{dept?.createdDate ? format(new Date(dept.createdDate), "dd MMM, yyyy") : "-"}</span>

                                                    </td>
                                                    <td style={LightDark}>
                                                        {dept.employeeNames?.length > 0 ? dept.employeeNames.length : 0}
                                                    </td>

                                                    <td style={LightDark}>
                                                        <div className="d-flex gap-3">
                                                            <Icon
                                                                icon="hugeicons:view"
                                                                width="20"
                                                                className="cursor-pointer"
                                                                style={{ color: '#00AFEF' }}
                                                                onClick={() => {
                                                                    setSelectedDept(dept);
                                                                    setShowViewDeptModal(true);
                                                                }}
                                                            />
                                                            <Icon
                                                                icon="mdi:edit"
                                                                width="20"
                                                                className="cursor-pointer"
                                                                style={{ color: '#00AFEF' }}
                                                                onClick={() => {
                                                                    setSelectedDept(dept);
                                                                    setShowEditDeptModal(true);
                                                                }}
                                                            />
                                                            <Icon
                                                                icon="material-symbols:delete-outline"
                                                                width="20"
                                                                className="cursor-pointer"
                                                                style={{ color: '#DD0000' }}
                                                                onClick={() => {
                                                                    setSelectedDept(dept);
                                                                    setShowDeleteModal(true);
                                                                }}
                                                            />
                                                        </div>
                                                    </td>
                                                </tr>
                                            ))}

                                            {filteredData.length === 0 && (
                                                <tr>
                                                    <td colSpan="6" className="text-center text-muted py-3">
                                                        No Department Found
                                                    </td>
                                                </tr>
                                            )}
                                        </tbody>

                                    </table>

                                    {totalPages > 1 && (
                                        <div className="pagination-controls" style={{ marginTop: "30px", textAlign: "center" }}>
                                            <button
                                                disabled={currentPage === 0}
                                                onClick={() => setCurrentPage((prev) => prev - 1)}
                                            >

                                                <Icon
                                                    icon="iconamoon:arrow-left-2"
                                                    width="20"
                                                    height="20"
                                                    color="#606060"
                                                />
                                            </button>
                                            <span style={{ margin: "0 10px" }}>
                                                Page {currentPage + 1} of {totalPages}
                                            </span>
                                            <button
                                                disabled={currentPage + 1 >= totalPages}
                                                onClick={() => setCurrentPage((prev) => prev + 1)}
                                            >
                                                <Icon
                                                    icon="iconamoon:arrow-right-2"
                                                    width="20"
                                                    height="20"
                                                    color="#606060"
                                                />
                                            </button>
                                        </div>
                                    )}

                                </div>
                            ) : (
                                // GRID view
                                <div className="row mt-5 g-5">
                                    {filteredData.map((dept) => {
                                        const { background, color } = getDeptColors(dept?.name);
                                        return (
                                            <div key={dept.id} className="col-md-4  mb-3 ">
                                                <div className=" p-3 "
                                                    style={{
                                                        boxShadow: '0px 0px 17px 0px #0000001F',
                                                        borderRadius: '10px',
                                                        backgroundColor: '#FFFFFF'
                                                    }}>
                                                    <span
                                                        style={{
                                                            width: '76px',
                                                            height: '76px',
                                                            position: 'relative',
                                                            top: '-50px',
                                                            left: '10px',
                                                            borderRadius: '10px',
                                                            border: '1px solid #DEDEDE',
                                                            display: 'flex',
                                                            alignItems: 'center',
                                                            justifyContent: 'center',
                                                            fontSize: '28px',
                                                            fontWeight: '500',
                                                            background,
                                                            color,
                                                        }}
                                                    >
                                                        {dept?.name
                                                            ? dept.name
                                                                .split(' ')
                                                                .slice(0, 2)                 // split into words
                                                                .map(word => word[0])     // take first letter of each
                                                                .join('')                 // combine
                                                                .toUpperCase()            // make uppercase
                                                            : 'SD'}
                                                    </span>
                                                    <div className='d-flex justify-content-between align-item-center'>
                                                        <h6 style={LighterBig} className=''>{dept?.name}</h6>
                                                        <span
                                                            style={{
                                                                backgroundColor: dept.status === "Active" ? "#EFFFED" : "#FEF2F2",
                                                                color: dept.status === "Active" ? "#1EA70C" : "#A70C0C",
                                                                padding: "5px 5px",
                                                                borderRadius: "10px",
                                                                fontWeight: 500,
                                                                fontSize: "0.9rem",
                                                            }}
                                                        >
                                                            {dept.status || "N/A"}
                                                        </span>

                                                    </div>

                                                    <p
                                                        style={{
                                                            ...LightDark,
                                                            display: 'flex',
                                                            alignItems: 'center',
                                                            gap: '8px', // adds space between image and text
                                                            marginBottom: '0.25rem'
                                                        }}
                                                    >
                                                        {/* <span
                                                            style={{
                                                                height: '30px',
                                                                width: '30px',
                                                                border: '1px solid #F0F0F0',
                                                                borderRadius: '50%',
                                                                overflow: 'hidden',
                                                                flexShrink: 0 // prevents shrinking in flex layout
                                                            }}
                                                        >
                                                            <img
                                                                src={profileImage}
                                                                alt="Profile"
                                                                style={{ height: '100%', width: '100%', objectFit: 'cover' }}
                                                            />
                                                        </span> */}
                                                        <span
                                                            className="rounded-circle d-flex justify-content-center align-items-center"
                                                            style={{
                                                                width: "30px",
                                                                height: "30px",
                                                                fontSize: "12px",
                                                                color: "#999",
                                                                backgroundColor: "#F0F0F0",
                                                                border: "1px solid #F0F0F0 ",
                                                            }}
                                                        >
                                                            <Icon icon="proicons:person" className="fs-5 " style={{}} />
                                                        </span>
                                                        {dept.headName}
                                                    </p>


                                                    {/* <p className="small text-muted">
                                                        <Icon icon='ic:outline-email' className='me-2 fs-4 fs' />{dept.email}</p>
                                                    <p className="small text-muted">
                                                        <Icon icon='material-symbols:call-outline' className='me-2 fs-4 fs' /> {dept.phone}</p> */}
                                                    <p className="small text-muted">
                                                        <Icon icon='mingcute:time-line' className='me-2 fs-4 fs' /> <span>{dept?.createdDate ? format(new Date(dept.createdDate), "dd MMM, yyyy") : "-"}</span></p>
                                                    <p className="small text-muted"><Icon icon='material-symbols:group-outline' className='me-2 fs-4 fs' /> {dept.employeeNames?.length > 0 ? dept.employeeNames.length : 0}</p>


                                                    <span className="d-flex gap-2 flex-wrap align-items-center">
                                                        {/* View Button */}
                                                        <button
                                                            className="btn d-flex align-items-center gap-2"
                                                            style={{
                                                                border: '1px solid #00AFEF',
                                                                borderRadius: '10px',
                                                                padding: '10px',
                                                            }}
                                                            onClick={() => {
                                                                setSelectedDept(dept);       // store the clicked department
                                                                setShowViewDeptModal(true);  // open modal
                                                            }}

                                                        >
                                                            <Icon icon="hugeicons:view" className="fs-5" style={{ color: '#00AFEF' }} />
                                                            <span className="d-none d-md-inline" style={{ color: '#00AFEF' }}>View</span>
                                                        </button>

                                                        {/* Edit Button */}
                                                        <button
                                                            className="btn d-flex align-items-center gap-2"
                                                            style={{
                                                                border: '1px solid #00AFEF',
                                                                borderRadius: '10px',
                                                                padding: '10px',
                                                            }}
                                                            onClick={() => {
                                                                setSelectedDept(dept);
                                                                setShowEditDeptModal(true);
                                                            }}
                                                        >
                                                            <Icon icon="mdi:edit" className="fs-5" style={{ color: '#00AFEF' }} />
                                                            <span className="d-none d-md-inline" style={{ color: '#00AFEF' }}>Edit</span>
                                                        </button>

                                                        {/* Delete Icon */}
                                                        <Icon
                                                            icon="material-symbols:delete-outline"
                                                            className="ms-md-3 cursor-pointer"
                                                            style={{ color: '#DD0000', height: '40px', width: '26px' }}
                                                            onClick={() => {
                                                                setSelectedDept(dept);
                                                                setShowDeleteModal(true);
                                                            }}
                                                        />
                                                    </span>


                                                </div>
                                            </div>
                                        )
                                    })}
                                </div>
                            )}

                            {/* Modals */}
                            {/* <ViewDepartment
                                show={showViewDeptModal}
                                employeeData={selectedDept}
                                handleClose={() => setShowViewDeptModal(false)}
                            /> */}
                            <ViewDepartment
                                show={showViewDeptModal}
                                handleClose={() => setShowViewDeptModal(false)}
                                employeeData={selectedDept}
                                onEdit={(dept) => {
                                    setSelectedDept(dept);
                                    setShowViewDeptModal(false);   // close view modal
                                    setShowEditDeptModal(true);    // open edit modal
                                }}
                                onDelete={(dept) => {
                                    setSelectedDept(dept);
                                    setShowViewDeptModal(false);
                                    setShowDeleteModal(true);
                                }}
                            />
                            <EditDepartment
                                show={showEditDeptModal}
                                employeeData={selectedDept}
                                handleClose={() => setShowEditDeptModal(false)}
                                onDepartmentUpdated={fetchDepartments}
                            />
                            <DeleteDepartment
                                show={showDeleteModal}
                                onCancel={() => setShowDeleteModal(false)}
                                onConfirm={handleDeleteDepartment}
                                loading={isDeleting}
                                loadingMessage="Deleting department, please wait..."
                            />

                            <AddNewDepartment
                                show={showAddDeptModal}
                                handleClose={() => setShowAddDeptModal(false)}
                                handleSave={(newDept) => {
                                    setDepartments((prev) => [
                                        ...prev,
                                        {
                                            ...newDept,
                                            id: prev.length + 1,
                                            created: "13 Oct, 2025",
                                            employees: 0,
                                        },
                                    ]);
                                    setShowAddDeptModal(false);
                                }}
                            />
                        </>
                    )}

                    {/* ===== Roles Section ===== */}
                    {statusFilter === "Roles" && <Role />}
                </div>
            </div>
        </Layout>
    );
};


export default DepartmentRole;
